import { render } from "./S149369.vue?vue&type=template&id=43820a1f"
const script = {}
script.render = render

export default script